module.exports = __webpack_public_path__ + "catalog/items/stairs/L-shaped-stairs-with-turn/L-shaped-stairs-with-turn-icon.svg";